import React from "react";
import { motion } from "framer-motion";
import { blogs } from "../Blog";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const OtherBlogs = ({ currentSlug, isBlogDetail = false }) => {
  const displayedBlogs = blogs
    .filter((blog) => !currentSlug || blog.slug !== currentSlug)
    .slice(0, 3);

  return (
    <section className="other-blogs-section container">
      <motion.h2
        className="section-heading"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {isBlogDetail ? (
          <>Explore our <span>Other Blogs</span></>
        ) : (
          <>Insights, Ideas & <span>Updates from Onbbits</span></>
        )}
      </motion.h2>

      {!isBlogDetail && (
        <motion.p
          className="section-text top-text"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ delay: 0.1 }}
        >
          Explore expert insights, practical tips, and the latest trends in
          WhatsApp Business API, business automation, and customer engagement
          to help your business grow smarter.
        </motion.p>
      )}

      <div className="home-blogs-grid">
        {displayedBlogs.map((blog, index) => (
          <motion.article
            key={blog.slug || index}
            className="products-card"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            transition={{ delay: index * 0.15, duration: 0.6 }}
          >
            <div style={{ overflow: "hidden" }}>
              <img
                src={blog.img}
                alt={`${blog.title} | Onbbits`}
              />
            </div>

            <div className="blog-card">
              <h3 className="card-heading">{blog.title}</h3>

              <p className="section-text">{blog.desc}</p>

              <motion.a
                href={`/blog/${blog.slug}`}
                className="btn btn-primary"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.97 }}
              >
                Read More
              </motion.a>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default OtherBlogs;